import React from "react";

/**
 * Error Boundary to catch React errors including DOM manipulation issues
 * These errors commonly occur when third-party scripts modify the DOM
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a DOM manipulation error that can be ignored
    const errorMessage = error?.message || "";
    const isDOMError = 
      errorMessage.includes("removeChild") ||
      errorMessage.includes("insertBefore") ||
      errorMessage.includes("appendChild") ||
      errorMessage.includes("NotFoundError");
    
    // For DOM errors caused by third-party scripts, don't show error UI
    if (isDOMError) {
      console.warn("DOM manipulation error caught (likely from third-party scripts):", errorMessage);
      return { hasError: false, error: null };
    }
    
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    const errorMessage = error?.message || "";
    const isDOMError = 
      errorMessage.includes("removeChild") ||
      errorMessage.includes("insertBefore") ||
      errorMessage.includes("appendChild") ||
      errorMessage.includes("NotFoundError");
    
    if (!isDOMError) {
      console.error("Application error:", error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-black flex items-center justify-center p-4">
          <div className="text-center max-w-md">
            <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <h1 className="text-xl font-bold text-white mb-2">Algo salió mal</h1>
            <p className="text-gray-400 mb-4">
              Ha ocurrido un error inesperado. Por favor, recarga la página.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-2 bg-yellow-500 text-black font-bold rounded-full hover:bg-yellow-400 transition-colors"
            >
              Recargar página
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
